/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginBgLogin: {
      backgroundColor: '#F7F8FB',
      height: 'calc(100vh - 48px)',
      overflowY: 'auto',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    billingPortalLoginLogo: {
      paddingTop: theme.spacing(9.125),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingLeft: '25%',
      paddingRight: '25%',
    },
    billingPortalSignInText: {
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(6.25),
      paddingBottom: theme.spacing(1.25),
    },
    rectangle: {
      boxSizing: 'border-box',
      height: theme.spacing(63.75),
      width: theme.spacing(43.25),
      border: '1px solid #E6E7EC',
      borderRadius: 8,
      boxShadow: '0 5px 30px 0 rgba(102,103,133,0.17)',
    },
    moreDetails: {
      paddigTop: theme.spacing(6.5),
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    moreDetailsLink: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    moreDetailsContainer: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(4),
    },
    google: {
      color: 'rgba(0,0,0,0.54)',
      marginLeft: theme.spacing(-1),
    },
    github: {
      color: 'rgba(0,0,0,0.8)',
      marginRight: theme.spacing(1),
    },
    microsoft: {
      color: 'rgba(0,0,0,0.8)',
      marginRight: theme.spacing(1),
    },
    loginBtn: {
      fontFamily: 'Roboto',
      paddingLeft: 8,
      paddingRight: 8,
      height: 40,
      width: theme.spacing(28.125),
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.5,
      borderRadius: 2,
      letterSpacing: 0.22,
      boxShadow: '0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)',
      marginTop: theme.spacing(1.5),
      backgroundColor: theme.palette.common.white,
      whiteSpace: 'nowrap',
      '&:hover, &:focus, &:active': {
        backgroundColor: '#EEEEEE',
        boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
      },
    },
    btnIcon: {
      marginRight: theme.spacing(3),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    msftBtnIcon: {
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(2),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    linkText: {
      color: theme.palette.primary.main,
      fontSize: 14,
    },
    identityProviderImage: {
      width: '129px',
      height: '32px',
    },
  })
);

export default useStyles;
